import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { jobLabelTextColor } from './job-label.util';

@Component({
  selector: 'app-job-option',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="pp-job-option">
      <span
        class="pp-job-option__pill"
        [style.backgroundColor]="colour || '#e2e8f0'"
        [style.color]="textColor"
        aria-hidden="true"></span>
      <span class="pp-job-option__text">
        <span class="pp-job-option__id">{{ jobId }}</span>
        <span *ngIf="jobTitle" class="pp-job-option__sep">·</span>
        <span *ngIf="jobTitle" class="pp-job-option__title">{{ jobTitle }}</span>
      </span>
    </span>
  `,
  styles: [
    `
      .pp-job-option {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        max-width: 100%;
        min-width: 0;
      }
      .pp-job-option__pill {
        width: 0.65rem;
        height: 0.65rem;
        border-radius: 999px;
        flex-shrink: 0;
      }
      .pp-job-option__text {
        display: inline-flex;
        align-items: baseline;
        gap: 0.35rem;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .pp-job-option__id {
        font-weight: 700;
        font-size: 0.8125rem;
      }
      .pp-job-option__title {
        font-size: 0.8125rem;
        color: var(--pp-text-muted, #64748b);
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
})
export class JobOptionComponent {
  @Input() jobId = '';
  @Input() jobTitle = '';
  @Input() colour = '#e2e8f0';

  get textColor(): string {
    return jobLabelTextColor(this.colour);
  }
}
